import request from '@/utils/request'

/**
 * 我的任務列表
 * @param {*} data
 */
export function workTaskMyTaskAPI(data) {
  return request({
    url: 'work/task/myTask',
    method: 'post',
    data: data
  })
}

/**
 * 新增任務
 * @param {*} data
 */
export function workTaskSaveAPI(data) {
  return request({
    url: 'work/task/save',
    method: 'post',
    data: data
  })
}

/**
 * 刪除任務
 * @param {*} data
 */
export function workTaskDeleteAPI(data) {
  return request({
    url: 'work/task/delete',
    method: 'post',
    data: data
  })
}

/**
 * 拖拽改變分類
 * @param {*} data
 */
export function workTaskUpdateTopAPI(data) {
  return request({
    url: 'work/task/updateTop',
    method: 'post',
    data: data
  })
}

/**
 * 專案列表
 * @param {*} data
 */
export function workIndexWorkListAPI(data) {
  return request({
    url: 'work/index/workList',
    method: 'post',
    data: data
  })
}

/**
 * 任務詳情
 * @param {*} data
 */
export function workTaskReadAPI(data) {
  return request({
    url: 'work/task/read',
    method: 'post',
    data: data
  })
}

/**
 * 任務編輯 -- 詳情頁總編輯
 * @param {*} data
 */
export function workTaskUpdateAPI(data) {
  return request({
    url: 'work/task/update',
    method: 'post',
    data: data
  })
}

/**
 * 編輯任務名
 * @param {*} data
 */
export function workTaskUpdateNameAPI(data) {
  return request({
    url: 'work/task/updateName',
    method: 'post',
    data: data
  })
}

/**
 * 設定截至日期
 * @param {*} data
 */
export function workTaskUpdateStoptimeAPI(data) {
  return request({
    url: 'work/task/updateStoptime',
    method: 'post',
    data: data
  })
}

/**
 * 任務參與人刪除新增
 * @param {*} data
 */
export function workTaskUpdateOwnerAPI(data) {
  return request({
    url: 'work/task/updateOwner',
    method: 'post',
    data: data
  })
}

/**
 * 新增刪除標籤
 * @param {*} data
 */
export function workTaskUpdateLableAPI(data) {
  return request({
    url: 'work/task/updateLable',
    method: 'post',
    data: data
  })
}

/**
 * 任務歸檔
 * @param {*} data
 */
export function workTaskArchiveAPI(data) {
  return request({
    url: 'work/task/archive',
    method: 'post',
    data: data
  })
}

/**
 * 優先順序
 * @param {*} data
 */
export function workTaskUpdatePriorityAPI(data) {
  return request({
    url: 'work/task/updatePriority',
    method: 'post',
    data: data
  })
}

/**
 * 子任務標記結束
 */
export function workTaskTaskOverAPI(data) {
  return request({
    url: 'work/task/taskOver',
    method: 'post',
    data: data
  })
}

/**
 * 操作記錄
 * @param {*} data
 */
export function workTaskReadLoglistAPI(data) {
  return request({
    url: 'work/task/readLoglist',
    method: 'post',
    data: data
  })
}

/**
 * 單獨刪除參與人
 * @param {*} data
 */
export function workTaskDelOwnerByIdAPI(data) {
  return request({
    url: 'work/task/delOwnerById',
    method: 'post',
    data
  })
}

/**
 * 任務評論新增
 * @param {*} data
 */
export function workTaskcommentSaveAPI(data) {
  return request({
    url: 'work/taskcomment/save',
    method: 'post',
    data
  })
}

/**
 * 任務評論刪除
 * @param {*} data
 */
export function workTaskcommentDeleteAPI(data) {
  return request({
    url: 'work/taskcomment/delete',
    method: 'post',
    data
  })
}

/**
 * 歸檔任務啟用
 * @param {*} data
 */
export function workTaskRecoverAPI(data) {
  return request({
    url: 'work/task/recover',
    method: 'post',
    data
  })
}
